import { DatePipe, NgFor, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Table } from 'primeng/table';
import { debounceTime } from 'rxjs';
import { StandardRequestService } from '../standard-request.service';
import { StandardRequestsFilterService } from '../standard-requests-filter.service';

@Component({
    selector: 'app-standard-requests-active-filters',
    templateUrl: './standard-requests-active-filters.component.html',
    standalone: true,
    imports: [NgFor, NgSwitch, NgIf, NgSwitchCase, DatePipe, TranslateModule]
})
export class StandardRequestsActiveFiltersComponent {

    formKeys: string[];
    formControls: Record<string, AbstractControl<any, any>>;
    queryId = '';
    personId = '';
    firstName = '';
    email = '';
    phoneNumber = '';
	@Input() table: Table;

	constructor(
		public readonly standardRequestsFilterService: StandardRequestsFilterService,
		public readonly standardRequestService: StandardRequestService
	) {
	    this.initializeFormControls();

	    this.standardRequestsFilterService.filterHandler()
	        .pipe(debounceTime(300))
	        .subscribe(() => {
	            this.standardRequestsFilterService.searchingByColumnFilter = true;
	            this.initializeFormControls();
	        });
	}

	initializeFormControls(): void {
	    this.formControls = this.standardRequestsFilterService.form.controls;
	    this.formKeys = [];

	    for (const key in this.formControls) {
	        if (Object.prototype.hasOwnProperty.call(this.formControls, key)) {
	            this.formKeys.push(key);
	        }
	    }

	    this.queryId = this.standardRequestsFilterService.form.controls['queryId'].value;
	    this.personId = this.standardRequestsFilterService.form.controls['personId'].value;
	    this.firstName = this.standardRequestsFilterService.form.controls['firstName'].value;
	    this.email = this.standardRequestsFilterService.form.controls['email'].value;
	    this.phoneNumber = this.standardRequestsFilterService.form.controls['phoneNumber'].value;
	}

	getFormControlObject(key: string): AbstractControl<any, any> {
	    return this.formControls[key];
	}

	isFilterActive(key: string): boolean {
	    const value = this.formControls[key].value;
	    return value != null && value !== '';
	}

	thereIsMoreThanOneFilterActive(): boolean {
	    return this.formKeys.filter(key => this.isFilterActive(key)).length >= 2;
	}

	clearFilter(key: string): void {
	    if (this[`${key}`]) this[`${key}`] = ''; // this.queryId = ''; this.personId = ''; this.firstName = ''; this.email = ''; this.phoneNumber = '';
	    this.standardRequestsFilterService.clearFilter(key);
	}

	clearAllFiltersAndGlobalSearch(): void {
	    this.queryId = '';
	    this.personId = '';
	    this.firstName = '';
	    this.email = '';
	    this.phoneNumber = '';
	    this.standardRequestsFilterService.clearAllFiltersAndGlobalSearch();

	    // reset sort field of the table
	    this.standardRequestsFilterService.resetSortField();
	    if (this.table) { this.table.reset(); }
	}
}
